import React from 'react';
import StatisticsDetailPage from './StatisticsDetailPage';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../../actions/report.actions';
import Loading from '../../../Helpers/Loading';
import Backend from '../../../Layouts/Backend';
import lookupActions from '../../../../actions/lookup.actions';
import helper from '../../../../utils/helper';
import moment from 'moment';

const dateFormat = 'MM/DD/yyyy';

class StatisticsDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      statisticsDetail: [],
      loading: false,
      isSubmitting: false,
      isFetching: false,
      errors: [],
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.lookup.groups !== prevState.groups) {
      state.groups = nextProps.lookup.groups;
    }
    if (nextProps.report.statisticsDetail !== prevState.statisticsDetail) {
      state.statisticsDetail = nextProps.report.statisticsDetail;
    }
    if (nextProps.report.isFetching !== prevState.isFetching) {
      state.isFetching = nextProps.report.isFetching;
    }
    state.errors = helper.centralizeError([
      nextProps.lookup.errors,
      nextProps.report.error,
    ]);
    return Object.keys(state).length ? state : null;
  }

  componentDidMount() {
    this.setState({ loading: true }, async () => {
      await this.props.lookupActions.getGroups();
      await this.props.reportActions.clearReport();
    });
    this.setState({ loading: false });
  }

  toUTC(dt) {
    return moment.utc(dt, dateFormat).format();
  }
  onRunReport = (values) => {
    const fromDate = this.toUTC(
      moment(moment(values.fromDate).minutes('00').seconds('00')).toDate(),
    );
    const toDate = this.toUTC(
      moment(moment(values.toDate).minutes('59').seconds('59')).toDate(),
    );
    this.props.history.push(
      `/reports/statistics-detail/result?groupId=${
        values.groupId
      }&sensorIds=${values.sensorIds.join(
        ',',
      )}&fromDate=${fromDate}&toDate=${toDate}&groupHours=${values.groupHours}`,
    );
  };
  render() {
    if (this.state.loading)
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    return (
      <StatisticsDetailPage
        {...this.state}
        onRunReport={this.onRunReport}
        columns={this.columns}
        defaultSorted={this.defaultSorted}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    lookup: state.lookup,
    report: state.report,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsDetail);
